<template>
  <div class="booking-details">
    <div class="card">
      <div class="card-header">
        <h2 class="my-3">Details van de stalling</h2>
      </div>
    </div>

    <accommodation :products="filterProducts('Storage')" />
    <booking-pitches />
  </div>
</template>

<script>
import config from "@/config";
import { mapState, mapGetters } from "vuex";

import Accommodation from "@/components/booking-details/Accommodation";
import BookingPitches from "@/components/booking-details/Pitches";

import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const ProductRepository = RepositoryFactory.get("ProductRepository");

export default {
  components: {
    Accommodation,
    BookingPitches
  },

  props: {
    id: { type: Number, default: null }
  },

  data: function () {
    return {
      config: config,
      products: []
    };
  },

  computed: {
    ...mapState("CurrentBooking", { booking: "booking", stay: "selectedStay" }),
    ...mapState("Campsites", ["currentCampsite"]),
    ...mapGetters({
      getBookingQueryType: "CurrentBooking/getBookingQueryType"
    })
  },

  mounted() {
    ProductRepository.getProducts(this.currentCampsite.id, this.getBookingQueryType(this.id))
      .then((response) => {
        this.products = response.data;
      })
      .catch((error) => {
        this.$notify({
          group: "app",
          type: "error",
          title: this.$i18n.t("general_error_title"),
          text: error.response.data.message
        });
      });
  },

  methods: {
    filterProducts: function (d) {
      return this.products.filter((p) => p.productDefinition.endsWith(d));
    }
  }
};
</script>
